/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const contentSharingLinkPermissionMaskMin = 0;
export const contentSharingLinkPermissionMaskMax = 63;

export const ContentSharingLink = zod.object({
  challengeLabel: zod.string().nullable(),
  createdAt: zod.string(),
  expiresAt: zod.string().nullable(),
  grantType: zod.enum(['LINK']),
  grantUuid: zod.uuid().describe('UUID v4 identifier'),
  hasPin: zod.boolean(),
  permissionMask: zod
    .int()
    .min(contentSharingLinkPermissionMaskMin)
    .max(contentSharingLinkPermissionMaskMax),
  permissions: zod.array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE'])),
  slug: zod.string().nullable(),
});

export type ContentSharingLink = zod.input<typeof ContentSharingLink>;
export type ContentSharingLinkOutput = zod.output<typeof ContentSharingLink>;
